import {Component, OnInit} from '@angular/core';
import {MerlinxAptEntry} from '../../../shared/interfaces/merlinx-apt-entry';
import {Observable, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {MerlinxService} from '../../../shared/services/merlinx.service';
import {MerlinxPassengerType} from '../../../shared/interfaces/merlinx-passenger-type';
import {NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MerlinxPassengers} from '../../../shared/interfaces/merlinx-passengers';
import * as dayjs from 'dayjs';
import {EngineMerlinxPassengersModalComponent} from '../engine-merlinx-passengers-modal/engine-merlinx-passengers-modal.component';
import {Params, Router} from '@angular/router';
import {MerlinxLandingTypes} from '../../../merlinx/models/merlinx-landing-types.enum';

@Component({
  selector: 'app-engine-merlinx-flights',
  templateUrl: './engine-merlinx-flights.component.html',
  styleUrls: ['./engine-merlinx-flights.component.scss']
})
export class EngineMerlinxFlightsComponent implements OnInit {

  constructor(private mxs: MerlinxService,
              private router: Router,
              private modalService: NgbModal) { }

  selectedDepartureAirport: MerlinxAptEntry;
  selectedArrivalAirport: MerlinxAptEntry;
  selectedPassengerType: MerlinxPassengerType;
  selectedDepartureDate: NgbDateStruct;
  selectedArrivalDate: NgbDateStruct;
  passengers: MerlinxPassengers = {
    adultsNum: 1,
    childrenNum: 0,
    childrenAges: []
  };

  twoWayFlight: boolean;
  isLoading = false;
  airports$: Observable<MerlinxAptEntry[]>;
  passengerTypes: MerlinxPassengerType[];
  airportQuery$ = new Subject<string>();

  ngOnInit(): void {
    this.twoWayFlight = true;
    this.populatePassengerTypes();
    this.airports$ = this.airportQuery$.pipe(
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      debounceTime(200),
      switchMap(e => this.mxs.airportQuery(e)),
      tap(() => this.isLoading = false)
    );
  }

  getAptItemName(item: MerlinxAptEntry): string {
    return `${item.cityName} - ${item.airportName} (${item.code}), ${item.countryName}`;
  }

  getPassengerString(): string {
    let retString = '';
    if (this.passengers.adultsNum > 1) {
      retString += `${this.passengers.adultsNum} Adulti`;
    } else {
      retString += `${this.passengers.adultsNum} Adulto`;
    }
    if (this.passengers.childrenNum === 1) {
      retString += `, ${this.passengers.childrenNum} Bambino`;
    }
    if (this.passengers.childrenNum > 1) {
      retString += `, ${this.passengers.childrenNum} Bambini`;
    }
    return retString;
  }

  populatePassengerTypes(): void {
    const stdPassenger: MerlinxPassengerType = {
      code: 'STD',
      name: 'Tariffa Standard',
      adult: true,
      child: true,
      infant: true
    };
    const resPassenger: MerlinxPassengerType = {
      code: 'RES',
      name: 'Tariffa Residenti',
      adult: true,
      child: true,
      infant: false
    };
    this.passengerTypes = [
      stdPassenger,
      resPassenger
    ];
    this.selectedPassengerType = stdPassenger;
  }

  openPassengersModal(): void {
    const passengersModalRef = this.modalService.open(EngineMerlinxPassengersModalComponent);
    passengersModalRef.componentInstance.passengers = this.passengers;
    passengersModalRef.result.then((x: MerlinxPassengers) => {
      this.passengers = x;
    }).catch(error => {
      // do nothing
    });
  }

  canSearch(): boolean {
    const conditions = [];
    conditions.push(!!this.selectedDepartureAirport);
    conditions.push(!!this.selectedArrivalAirport);
    conditions.push(!!this.selectedDepartureDate);
    if (this.twoWayFlight) {
      conditions.push(!!this.selectedArrivalDate);
    }
    return !conditions.includes(false);
  }

  convertDateFromNgb(input: NgbDateStruct): string {
    return dayjs(`${input.day}-${input.month}-${input.year}`, 'D-M-YYYY').format('DD.MM.YYYY');
  }

  convertDateFromDate(input: Date): string {
    return dayjs(input).format('YYYYMMDD');
  }

  doSearch(): void {
    const codeDepartureApt = this.selectedDepartureAirport.code;
    const codeArrivalApt = this.selectedArrivalAirport.code;
    const depDate = this.convertDateFromNgb(this.selectedDepartureDate);

    const numAdults = this.passengers.adultsNum;
    const numChildren = this.passengers.childrenNum;
    const agesChilds = this.passengers.childrenAges.map(e => this.convertDateFromDate(e));
    const passengerType = this.selectedPassengerType;

    const queryParams: Params = {};

    let url = `m/${MerlinxLandingTypes.FLIGHTS}`;
    if (this.twoWayFlight) {
      url += '/andata_e_ritorno';
    } else {
      url += '/solo_andata';
    }
    queryParams.transport = 'rflight';
    queryParams.dep = codeDepartureApt;
    queryParams.desc = codeArrivalApt;
    queryParams.depd = depDate;
    queryParams.passengerTypes = passengerType.code;
    if (this.twoWayFlight) {
      const retDate = this.convertDateFromNgb(this.selectedArrivalDate);
      queryParams.retd = retDate;
    }
    queryParams.ad = numAdults;
    queryParams.ch = numChildren;
    agesChilds.forEach((e, k) => {
      queryParams['cha[' + k + ']'] = e;
    });
    this.router.navigate([url], {queryParams});
  }

}
